import { toast } from "sonner"

import { TextFieldModel, type TextFieldModelParams } from "@/components/Chat/NewProject/RepositoryUrlMessageModel.ts"


export class ProjectNameMessageModel extends TextFieldModel {
  constructor(params: TextFieldModelParams) {
    super({
      ...params,
      name: "ProjectNameMessageModel"
    })
  }

  readonly validate = async () => {
    return null
  }

  readonly submitImpl = async () => {
    await this.context.queries.apiClient.setProjectName(this.taskId, this.value.get(), false)
    toast.info(`Project is renamed to "${this.value.get()}"`)
  }
}